import { useEffect } from "react";

// TypeScript에서 window.Kakao를 사용하기 위한 선언
declare global {
  interface Window {
    Kakao: any;
  }
}

const KakaoShareButton = () => {
  useEffect(() => {
    // Kakao SDK가 로드되어 있고, 아직 초기화되지 않았다면 초기화합니다.
    if (window.Kakao && !window.Kakao.isInitialized()) {
      window.Kakao.init(process.env.REACT_APP_KAKAO_JS); // 본인의 키로 변경!
    }
  }, []);

  const handleKakaoShare = () => {
    if (!window.Kakao) {
      console.error("Kakao SDK가 로드되지 않았습니다.");
      return;
    }

    // Kakao.Share.sendDefault를 이용해 공유하기 팝업을 호출합니다.
    window.Kakao.Share.sendDefault({
      objectType: "feed",
      content: {
        title: "오늘 당신의 행운은?",
        description: "혹시 모른다! 오늘 엄청난 대운이 기다릴지도?!",
        imageUrl: "https://today.sajutalktalk.com/share/ks_thumbnail.png",
        link: {
          mobileWebUrl: "https://today.sajutalktalk.com/?trkId=v7ms8r",
          webUrl: "https://today.sajutalktalk.com/?trkId=v7ms8r",
        },
      },
      buttons: [
        {
          title: "운세 보러가기",
          link: {
            mobileWebUrl: "https://today.sajutalktalk.com/?trkId=v7ms8r",
            webUrl: "https://today.sajutalktalk.com/?trkId=v7ms8r",
          },
        },
      ],
    });
  };

  return (
    <button className="kakao_button" onClick={handleKakaoShare}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        style={{
          width: "1em",
          height: "1em",
          marginRight: "8px",
          marginBottom: "-2px",
        }}
      >
        {/* !Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free */}
        <path d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3.7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z" />
      </svg>
      카카오로 공유하기
    </button>
  );
};

export default KakaoShareButton;
